// src/components/BackToTop.js
import React, { useState, useEffect } from 'react';
import '../Pages/Style.css';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    setVisible(window.scrollY > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);
    return () => window.removeEventListener('scroll', toggleVisible);
  }, []);

  return (
    <button
      className="back-to-top"
      onClick={scrollToTop}
      style={{ display: visible ? 'block' : 'none' }}
      title="Back to Top"
    >
      ⬆
    </button>
  );
};

export default BackToTop;
